import { z } from "zod"

import { CertificateStatus } from "@tfg/types/schemas/modules/traceability/domain/certificate.types"

export const certificateUpdateSchema = z
  .object({
    typeId: z.string().uuid(),
    reference: z.string().min(1),
    productionSiteId: z.string().uuid(),
    issueDate: z.coerce
      .date()
      .nullable()
      .refine((value) => value !== null),
    expiryDate: z.coerce.date().nullable(),
    score: z.string().nullable(),
    status: z.nativeEnum(CertificateStatus),
    name: z.string().nullable(),
    rejectionMessage: z.string().nullable(),
    purchaseOrderId: z.string().uuid().nullable(),
    certificationBody: z.string().nullable(),
    certifiedCompanyName: z.string().nullable(),
    certifiedCompanyAddress: z.string().nullable(),
    certifiedCompanyLicenseNumber: z.string().nullable(),
    productCategories: z.string().array(),
    productDetails: z.string().array(),
    processingSteps: z.string().array(),
    buyerOfCertifiedProducts: z.string().nullable(),
    certifiedWeight: z.string().nullable(),
    linkedScopeCertificateNumber: z.string().nullable(),
  })
  .partial()

export type CertificateUpdateDto = z.infer<typeof certificateUpdateSchema>
